import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const VAYCRAY_API_KEY = process.env.REACT_APP_VAYCRAY_API_KEY;

export const openVaycrayCheckout = (vaycraySlug) => {
  if (window.VaycrayCheckout) {
    window.VaycrayCheckout.open({
      eventSlug: vaycraySlug,
      apiKey: VAYCRAY_API_KEY,
      onSuccess: (data) => {
        alert(`Booking confirmed! Booking ID: ${data.bookingId}`);
      },
      onClose: () => {},
    });
  } else {
    window.open(`https://www.vaycray.com/events/${vaycraySlug}`, '_blank');
  }
};

export const api = {
  getEvents: () => axios.get(`${API}/events`),
  getFeaturedEvents: () => axios.get(`${API}/events/featured`),
  getEvent: (slug) => axios.get(`${API}/events/${slug}`),
  getGallery: () => axios.get(`${API}/gallery`),
  getSettings: () => axios.get(`${API}/settings`),
  submitContact: (data) => axios.post(`${API}/contact`, data),
  subscribeNewsletter: (data) => axios.post(`${API}/newsletter`, data),
};
